import { Link } from "react-router-dom";

const links = [
  { label: "Home", to: "/" },
  { label: "Blog", to: "/blog" },
  { label: "Free Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export default function PageHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-twilight/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 md:px-10">
        <Link to="/" data-testid="page-logo" className="flex items-center gap-2">
          <span className="text-gold text-xl">✦</span>
          <span className="font-display text-lg font-semibold tracking-tight text-cream md:text-xl">
            Hannah Series Official
          </span>
        </Link>
        <div className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`page-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-body text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </nav>
    </header>
  );
}
